import React, { useState } from 'react';
import { LegalModal } from './ui/LegalModal';
import { Shield, FileText } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-maternal-brown text-maternal-cream py-8 md:py-12" data-id="element-34">
        <div className="container mx-auto px-4 text-center" data-id="element-35">
          <p className="text-maternal-cream/80 mb-4 font-heading text-xl" data-id="element-36">
            Conecta con tu Adolescente
          </p>
          <p className="text-sm text-maternal-cream/60 mb-6 max-w-2xl mx-auto" data-id="element-37">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm text-maternal-cream/60" data-id="element-38">
            <button onClick={() => setShowTerms(true)} className="hover:text-maternal-amber transition-colors flex items-center gap-1.5" data-id="element-39">
              <FileText className="w-3.5 h-3.5" data-id="element-40" />
              Términos y Condiciones
            </button>
            <span data-id="element-41">|</span>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-maternal-amber transition-colors flex items-center gap-1.5" data-id="element-42">
              <Shield className="w-3.5 h-3.5" data-id="element-43" />
              Política de Privacidad
            </button>
          </div>
          <p className="text-xs text-maternal-cream/40 mt-8" data-id="element-44">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-45">
        <p className="font-semibold text-maternal-brown" data-id="element-46">
          Última actualización: Marzo 2026
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-47">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-48">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptás estos Términos y Condiciones en su totalidad. Si no
          estás de acuerdo con alguna parte de estos términos, te pedimos que no
          utilices nuestro sitio.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-49">
          2. Descripción del Producto
        </h3>
        <p data-id="element-50">
          Ofrecemos un producto digital educativo denominado "Conecta con tu
          Adolescente en 7 Días", que incluye guías, scripts de comunicación,
          hojas de trabajo y material complementario en formato descargable.
          Este producto tiene fines exclusivamente educativos e informativos y
          no reemplaza el asesoramiento profesional de un psicólogo, terapeuta o
          profesional de la salud mental.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-51">
          3. Proceso de Compra y Acceso
        </h3>
        <p data-id="element-52">
          Una vez realizado el pago, recibirás acceso inmediato al material
          digital. El acceso es personal e intransferible. No está permitido
          compartir, distribuir, revender ni reproducir el contenido total o
          parcialmente sin autorización expresa por escrito.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-53">
          4. Precios y Pagos
        </h3>
        <p data-id="element-54">
          Los precios publicados pueden variar según tu ubicación geográfica y
          la conversión de moneda aplicable. Todos los pagos se procesan a
          través de plataformas de pago seguras de terceros. No almacenamos
          información de tarjetas de crédito ni datos financieros en nuestros
          servidores.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-55">
          5. Política de Reembolso
        </h3>
        <p data-id="element-56">
          Dado que se trata de un producto digital con acceso inmediato, no se
          ofrecen reembolsos una vez que el material ha sido entregado y
          descargado. Si experimentás algún problema técnico para acceder al
          contenido, contactanos y te ayudaremos a resolverlo.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-57">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-58">
          Todo el contenido de este sitio web y del producto digital, incluyendo
          textos, gráficos, logotipos, imágenes y material descargable, está
          protegido por las leyes de propiedad intelectual. Queda prohibida su
          reproducción, distribución o modificación sin autorización previa.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-59">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-60">
          Los resultados pueden variar según cada persona y situación familiar.
          No garantizamos resultados específicos. El contenido se proporciona
          "tal cual" y no nos hacemos responsables por decisiones tomadas en
          base al material proporcionado.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-61">
          8. Modificaciones
        </h3>
        <p data-id="element-62">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. Las modificaciones entrarán en vigor desde su
          publicación en este sitio web.
        </p>
      </LegalModal>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-63">
        <p className="font-semibold text-maternal-brown" data-id="element-64">
          Última actualización: Marzo 2026
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-65">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-66">
          Recopilamos información limitada necesaria para procesar tu compra y
          brindarte acceso al producto digital. Esto puede incluir: nombre,
          dirección de correo electrónico, país de origen (detectado
          automáticamente para conversión de moneda) e información de pago
          procesada por terceros.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-67">
          2. Uso de la Información
        </h3>
        <p data-id="element-68">
          Utilizamos tu información exclusivamente para: procesar y entregar tu
          compra, enviarte el material adquirido, brindarte soporte técnico si
          lo necesitás y mejorar nuestros productos y servicios. No vendemos,
          alquilamos ni compartimos tu información personal con terceros con
          fines comerciales.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-69">
          3. Cookies y Tecnologías de Seguimiento
        </h3>
        <p data-id="element-70">
          Utilizamos cookies y tecnologías similares, incluyendo el Píxel de
          Meta (Facebook), para analizar el tráfico del sitio, medir la
          efectividad de nuestras campañas publicitarias y mejorar tu
          experiencia de navegación. Podés configurar tu navegador para rechazar
          cookies, aunque esto podría afectar la funcionalidad del sitio.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-71">
          4. Servicios de Terceros
        </h3>
        <p data-id="element-72">
          Utilizamos servicios de terceros para el procesamiento de pagos y
          análisis web. Estos servicios tienen sus propias políticas de
          privacidad y te recomendamos revisarlas. No somos responsables de las
          prácticas de privacidad de estos terceros.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-73">
          5. Seguridad de los Datos
        </h3>
        <p data-id="element-74">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal contra acceso no autorizado, alteración o
          destrucción. Sin embargo, ningún método de transmisión por Internet es
          100% seguro y no podemos garantizar seguridad absoluta.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-75">
          6. Tus Derechos
        </h3>
        <p data-id="element-76">
          Tenés derecho a acceder, rectificar o solicitar la eliminación de tus
          datos personales. Para ejercer estos derechos, podés comunicarte con
          nosotros a través de los canales disponibles en nuestro sitio.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-77">
          7. Menores de Edad
        </h3>
        <p data-id="element-78">
          Este sitio y nuestros productos están dirigidos a personas mayores de
          18 años. No recopilamos intencionalmente información de menores de
          edad.
        </p>

        <h3 className="font-bold text-maternal-brown text-lg mt-4" data-id="element-79">
          8. Cambios en esta Política
        </h3>
        <p data-id="element-80">
          Podemos actualizar esta Política de Privacidad periódicamente. Te
          notificaremos sobre cambios significativos publicando la nueva
          política en este sitio con la fecha de actualización correspondiente.
        </p>
      </LegalModal>
    </>;
}